export const PLANS = [
    {
        name: "Free",
        description: "Trial version to get familiar with BitHarbor.",
        price: "INR 0",
        billed: "/mo",
        link: "/auth/signup",
        heading: "Free Plan Features",
        features: [
            "BitHarbor Platform",
            "Top 5 Coin Ranks",
            "All Exchanges Rank",
            "Basic Analytics",
        ]
    },
    {
        name: "Pro",
        description: "Access more than 100 cryptocurrencies",
        price: "INR 2499",
        billed: "/mo",
        link: "https://buy.stripe.com/test_9AQdSx6wa9Eb3G84gp",
        heading: "Pro Plan Features",
        features: [
            "BitHarbor Platform",
            "All Coins Rank",
            "All Exchanges Rank",
            "Basic Analytics",
            "24/7 Customer Support"
        ]
    },
    {
        name: "Premium",
        description: "Full access with all features unlocked.",
        price: "INR 4499",
        billed: "/mo",
        link: "https://buy.stripe.com/test_fZe9Ch5s603Ba4w9AL",
        heading: "Premium Plan Features",
        features: [
            "Advanced Analytics",
            "BitHarbor Platform",
            "All Coin Ranks",
            "All Exchanges Rank",
            "24/7 Customer Support"
        ]
    },
]